import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { Dex } from 'src/app/models/dex.model';

@Component({
    selector: 'app-list-search-dates-combo-report',
    templateUrl: './list-search-dates-combo-report.component.html',
    styleUrls: ['./list-search-dates-combo-report.component.scss'],
    standalone: false
})
export class ListSearchDatesComboReportComponent implements OnInit {

  @Input() searchBut: boolean = false;
  @Input() addDownload: boolean = false;
  @Input() button_name: string = '';
  @Input() dataInTable: boolean = false;
  @Input() maxDays: number = 0;
  hideFilter = true
 
  @Input() hideHeader: boolean = false;
  @Input() filterArray: any = [{id: 0, name: ''}];
  form?: UntypedFormGroup;
  hasDates: boolean = false;
  @Input() dexs: Dex [] = [];

  @Output() reportDownload = new EventEmitter<any>();
  @Output() filterComboChange = new EventEmitter<number>();
  today = new Date(); 
  selectDex = true;
  maxDate = new Date(); 

  constructor(private fb: UntypedFormBuilder, ) {

  }

  ngOnInit() {

    this.form = this.fb.group({
      search: ['0', []],
      startDate: ['', []],
      endDate: ['', []],
      dex: ['', [Validators.required]],
    });

    this.form.get("search")?.valueChanges.subscribe(x => {
      if (x == '0') {
        this.selectDex = true;
        this.form?.get('startDate')?.setValue(null);
        this.form?.get('endDate')?.setValue(null);
        this.form?.markAsPristine();
        this.form?.get('startDate')?.setValidators(null);
        this.form?.get('endDate')?.setValidators(null);
        this.form?.get('dex')?.setValidators([Validators.required]);
        this.form?.get('dex')?.updateValueAndValidity();
        this.form?.get('startDate')?.updateValueAndValidity();
        this.form?.get('endDate')?.updateValueAndValidity();

      } else {
        this.selectDex = false;
        this.form?.get('dex')?.setValue('');
        this.form?.markAsPristine();
        this.form?.get('dex')?.setValidators(null);
        this.form?.get('startDate')?.setValidators([Validators.required]);
        this.form?.get('endDate')?.setValidators([Validators.required]);
        this.form?.get('dex')?.updateValueAndValidity();
        this.form?.get('startDate')?.updateValueAndValidity();
        this.form?.get('endDate')?.updateValueAndValidity();
      }
      this.filterComboChange.emit(x);
   })

    this.form.get("startDate")?.valueChanges.subscribe(x => {
      if (x) {
        this.maxDate = x;
      }
    })
  }


  sendReporthButton(){
    let momentStringStart = '';
    let momentStringEnd = '';
    if (this.form?.get('startDate')?.value) {
      let momentObj = moment(this.form?.get('startDate')?.value);
      momentStringStart = momentObj.format('YYYY-MM-DD')
    }
    if (this.form?.get('endDate')?.value) {
      let momentObj = moment(this.form?.get('endDate')?.value);
      momentStringEnd = momentObj.format('YYYY-MM-DD')
    }
    this.reportDownload.emit({values: [momentStringStart, momentStringEnd], value: this.form?.get('dex')?.value});
  }

  verifyStart() {
    if (this.form?.get('startDate')?.value) {
      let momentObj = moment(this.form?.get('startDate')?.value, 'YYYY-MM-DD').add(this.maxDays, 'days');
      return momentObj.toDate();
    }
    return this.today;
  }

}
